import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent],
    selector: 'app-delete-edit-button',
    templateUrl: './delete-edit-button.component.html',
})
export class DeleteEditButtonComponent {
    public readonly delete = output<void>();
    public readonly disabled = input(false);
    public readonly tooltip = input('');

    protected readonly ButtonType = ButtonType;
}
